import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import styles from './ContextMenu.css';

import SvgIcon from '@material-ui/core/SvgIcon';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactComponent as BarsIcon } from '@fortawesome/fontawesome-pro/svgs/solid/bars.svg';

// import { bars as falBars } from '@fortawesome/fontawesome-pro/js/light';
// import { bars as farBars } from '@fortawesome/fontawesome-pro/js/regular';
// import { bars as fasBars } from '@fortawesome/fontawesome-pro/js/solid';

const actions = {};

/** ContextMenu component description */
class ContextMenu extends Component {
    constructor(props) {
        super(props);
        // this.xxx = props.xxx;

        this.state = {
            open: false
        }

        this.handleClick = this.handleClick.bind(this);

        this.toggleVisibility = this.toggleVisibility.bind(this);
    }

    handleClick(e){
        // console.log('CONTEXT MENU CLICK' , e.target);
        if (e.target.classList.contains('togglebutton')) {
            this.toggleVisibility();
        }
    }

    componentDidMount() {
        console.log('ContextMenu', this.props.eventSource.current !== undefined);
        if (this.props.eventSource.current) {
            this.props.eventSource.current.addEventListener('click', this.handleClick, false);
        }
    }
    componentWillUnmount() {
        if (this.props.eventSource.current) {
            this.props.eventSource.current.removeEventListener('click', this.handleClick);
        }
    }

    toggleVisibility() {
        console.log('toggle');
        this.setState({
            open: !this.state.open
        })
    }

    // onTap={this.handleClick}
    // onClick={this.handleClick}

    render() {
        return <div className="ContextMenu">
            <div
                className="togglebutton clickable"
            >
                {/* <FontAwesomeIcon
                    icon={["fas", "bars"]}
                /> */}
                <SvgIcon><BarsIcon /></SvgIcon>
            </div>

            { this.state.open ? 
                <div className="children">
                    {this.props.children}
                </div> : null
            }
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
    // return Object.assign({}, { z: state.xxx }, ownProps);
}

ContextMenu.displayName = "ContextMenuComponent";
const connectedComponent = connect(
    mapStateToProps,
    {
        ...actions
    }
)(ContextMenu);
connectedComponent.displayName = "ContextMenu";


ContextMenu.propTypes = {

};

export default connectedComponent;
export { ContextMenu as ContextMenuComponent };